import { useState } from 'react';
/**
 * `ClickableHelpText` renders a help icon that toggles a Material UI `Tooltip`
 * on click.
 *
 * The tooltip is controlled via local state (`openTooltip`) and has hover,
 * focus, and touch listeners disabled so it behaves strictly as click-to-open.
 * `disablePortal` is enabled to keep the tooltip within the current DOM tree.
 */
import { Tooltip, Typography } from '@mui/material';
import HelpOutlineSharpIcon from '@mui/icons-material/HelpOutlineSharp';

interface ClickableHelpTextProps {
  helpText: string | JSX.Element;
}

const ClickableHelpText = ({
  helpText
}: ClickableHelpTextProps): JSX.Element => {
  const [openTooltip, setOpenTooltipValue] = useState(false);

  const toggleClick = () => {
    setOpenTooltipValue(!openTooltip);
  };

  return (
    <Tooltip
      onClose={toggleClick}
      open={openTooltip}
      title={
        <Typography sx={{ whiteSpace: 'pre-line' }} component='text'>
          {helpText}
        </Typography>
      }
      arrow
      PopperProps={{
        disablePortal: true
      }}
      disableFocusListener
      disableHoverListener
      disableTouchListener>
      <span data-testid='tooltip'>
        <HelpOutlineSharpIcon onClick={toggleClick} />
      </span>
    </Tooltip>
  );
};

export default ClickableHelpText;
